/**
 * Pushes authenticated user fields into `window.dataLayer` for Google Tag Manager.
 *
 * Configure Data Layer Variables in GTM for `auth0_user_id`, `user_email`, and
 * `account_id`. Trigger on custom event `ept_user_context`.
 */

export interface EptGtmUserPayload {
  auth0_user_id: string | null;
  user_email: string | null;
  account_id: number | null;
}

const EVENT_NAME = 'ept_user_context';

/**
 * Updates the data layer with the current user's Auth0 id, email, and account id.
 * Pass nulls when the user is logged out so GTM can clear or ignore prior values.
 */
export function pushEptUserToDataLayer(payload: EptGtmUserPayload): void {
  if (typeof window === 'undefined') {
    return;
  }
  window.dataLayer = window.dataLayer ?? [];
  window.dataLayer.push({
    event: EVENT_NAME,
    auth0_user_id: payload.auth0_user_id,
    user_email: payload.user_email,
    account_id: payload.account_id,
  });
}
